import { Component, ElementRef, ViewChild } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Api } from "src/app/services/api";
import { Globals } from "src/app/services/globals";
import { availableExaktaTShirtSKUs } from "../../../../../../../common/common-third-party/exakta/skus/available";
import { availableTexPrintClothesSKUs } from "../../../../../../../common/common-third-party/texprint/skus/available";
import { mugColors } from "../../../../../../../common/common-helpers/sku";
@Component({
    selector: "help",
    templateUrl: "./help.component.html",
    styleUrls: ["./help.component.scss"],
    standalone: false
})
export class HelpComponent {

  availableClothesSKUs = availableTexPrintClothesSKUs;
  mugColors = mugColors;
  skuExamplesExpanded = false;
  private paramsSubscription?: Subscription;
  private fragmentSubscription?: Subscription;
  constructor(
    private api: Api,
    private router: Router,
    private route: ActivatedRoute,
    public globals: Globals,
    private sanitizer: DomSanitizer,
  ) {
  }

  async ngOnInit() {
    this.paramsSubscription = this.route.params.subscribe(
      async (params: any) => {
      //  console.log(this.availableTShirtSKUs);
      },
    );

    this.fragmentSubscription = this.route.fragment.subscribe(fragment => {
      if (fragment !== 'sku-examples') {
        return;
      }

      this.skuExamplesExpanded = true;
      setTimeout(() => {
        document.getElementById('sku-examples')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 150);
    });
  }

  ngOnDestroy(): void {
    this.paramsSubscription?.unsubscribe();
    this.fragmentSubscription?.unsubscribe();

  }
}
